import { Icons } from '@cast/design-system';
type Props = Icons.IconProps & { level: 'high' | 'medium' | 'low' };

export const LevelArrows = ({ level = 'low', ...props }: Props) => {
  switch (level) {
    case 'high':
      return <Icons.ArrowUpRight {...props} />;
    case 'medium':
      return <Icons.ArrowRight {...props} />;
    case 'low':
      return <Icons.ArrowDownRight {...props} />;
  }

  return null;
};
